import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TransferListDSA from "./TransferListDSA";
import TransferListDSAMeasure from "./TransferListDSAMeasure";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setState, MidasAlignmentFilter, MDRAlignmentFilter, LocalAlignmentFilter } from "../scenarioSetupNewSlice";
import { useEffect } from "react";

export default function BasicAccordion() {
	const {
		DSAData,
		selectedPG_SKU_ADSs,
		selectedPG_SKU_ADSsID,
		selectedPGs,
		scDSA,
		DSAIdString,
		DSAIdStringPrev,
		editScDSAData,
		localForecastAlignment,
		countryID,
		midasFilterParameters,
		mdrFilterParameters,
		premdrFilterParameters,
		midasFilter,
		isLoadingAlignment,
		localFilterParameters,
		prelocalFilterParameters
	} = useSelector((store) => store.scenarioSetupNew);
	const dispatch = useDispatch();

	useEffect(() => {
		//if (DSAIdString !== DSAIdStringPrev) {
		prepareScDSA();
		//}
		//if(selectedPGs.length * DSAData.length !== scDSA.length){
		//	prepareScDSA();
		//}
	}, []);
	useEffect(() => {
		prepareScDSA();
	}, [DSAData]);
	// useEffect(() => {
	// 	handle_AlignmentChange();
	// }, [scDSA,selectedPG_SKU_ADSsID]);
	// useEffect(() => {
	// 	if (scDSA.length > 0 && midasFilter !== undefined && midasFilter !== null) {
	// 		let salignment = JSON.parse(JSON.stringify(scDSA));
	// 		let saCopy = salignment.find(x => x.dataSourceID === 5 && (x.skuid === selectedPG_SKU_ADSsID || x.productGroupID === selectedPG_SKU_ADSsID));
	// 		if (saCopy !== undefined) {
	// 			for (let i = 0; i < saCopy.attributes.length; i++) {
	// 				if (saCopy.attributes[i].attributeName === "Product") {
	// 					saCopy.attributes[i].attributeValues = midasFilter.product;
	// 				}
	// 				if (saCopy.attributes[i].attributeName === "Strength") {
	// 					saCopy.attributes[i].attributeValues = midasFilter.strength;
	// 				}
	// 				if (saCopy.attributes[i].attributeName === "Panel") {
	// 					saCopy.attributes[i].attributeValues = midasFilter.panel;
	// 				}
	// 			}
	// 		}
	// 		dispatch(setState("scDSA", salignment));
	// 	}

	// }, [midasFilter,selectedPG_SKU_ADSsID]);
	const setPreviousDataToScDSA = (preparedScDSA) => {
		console.log("scDSA", preparedScDSA);
		console.log("editScDSAData", editScDSAData);

		for (let i = 0; i < editScDSAData.length; ++i) {
			const editDSA = editScDSAData[i];

			for (let j = 0; j < preparedScDSA.length; ++j) {
				const prepDSA = preparedScDSA[j];

				const sameDS = editDSA.dataSourceID === prepDSA.dataSourceID;
				const sameSKU = editDSA.skuid !== null && prepDSA.skuid !== null && editDSA.skuid.toString() === prepDSA.skuid.toString();
				const samePG = editDSA.productGroupID !== null && prepDSA.productGroupID !== null && editDSA.productGroupID.toString() === prepDSA.productGroupID.toString();
				if (sameDS && (sameSKU || samePG)) {
					const editAttrList = editDSA.attributes;
					console.log("editAttrList", editAttrList);

					for (let k = 0; k < editAttrList.length; ++k) {
						const editAttr = editAttrList[k];

						if (editAttr.attributeValues[0].length > 0) {
							const editAttrValues = getArrayFromPipeSeparatedStr(editAttr.attributeValues[0]);
							prepDSA.attributes[k].selectedAttributeValues = editAttrValues.slice();
							for (let l = 0; l < editAttrValues.length; ++l) {
								prepDSA.attributes[k].attributeValues = prepDSA.attributes[k].attributeValues.filter((el) => el !== editAttrValues[l]);
							}
						}
					}
					const editmeasureList = editDSA.measure;
					if (editmeasureList.length > 0) {
						const measureValue = editmeasureList[0].measureValue;
						prepDSA.MeasureNumber = measureValue;
						const preMeasureList = prepDSA.measure;
						let mIdx = preMeasureList.findIndex((el) => el.measureValue === measureValue);
						if (mIdx > -1) {
							const selectedMeasure = preMeasureList[mIdx];
							prepDSA.selectedMeasure = [selectedMeasure];
							prepDSA.measure = preMeasureList.filter((el) => el.measureValue !== measureValue);
						}
					}
				}
			}
		}

		console.log("scDSA", preparedScDSA);
		// console.log("editScDSAData", editScDSAData);
	}
	const prepareScDSA = () => {
		let ischanges = false;
		let preparedScDSA = [];
		for (let spInd = 0; spInd < selectedPGs.length; ++spInd) {
			let sku_pg = selectedPGs[spInd];
			const { skuid, productGroupID } = getUniqueIDs(sku_pg);

			for (let dSrcInd = 0; dSrcInd < DSAData.length; ++dSrcInd) {
				let idx = scDSA.findIndex((el) => el.skuid === skuid && el.productGroupID === productGroupID && el.dataSourceID === DSAData[dSrcInd].dataSourceID);
				if (idx === -1) {
					ischanges = true;
					let dataSrc = DSAData[dSrcInd];
					let dataSourceID = dataSrc.dataSourceID;
					let dataSourceName = dataSrc.dataSourceName;

					let skuPG_DS = {
						dataSourceName,
						dataSourceID,
						skuid,
						productGroupID,
						attributes: [],
						measure: [],
						selectedMeasure: [],
						MeasureNumber: null,
						isVisible: true
					};
					const attributeList = dataSrc.attributes;
					const newAttrList = prepareAttributeList(attributeList);
					skuPG_DS.attributes = newAttrList;

					if (dataSrc.measure.length > 0) {
						const measureList = dataSrc.measure;
						const newMeasureList = prepareMeasureList(measureList);
						skuPG_DS.measure = newMeasureList;
					}
					preparedScDSA.push(skuPG_DS);
				}
			}
		}
		if (editScDSAData !== null) {
			setPreviousDataToScDSA(preparedScDSA);
		}
		for (let spInd = 0; spInd < selectedPGs.length; ++spInd) {
			let sku_pg = selectedPGs[spInd];
			const { skuid, productGroupID } = getUniqueIDs(sku_pg);

			for (let dSrcInd = 0; dSrcInd < DSAData.length; ++dSrcInd) {
				let idx = scDSA.findIndex((el) => el.skuid === skuid && el.productGroupID === productGroupID && el.dataSourceID === DSAData[dSrcInd].dataSourceID);
				if (idx > -1) {
					preparedScDSA.push(JSON.parse(JSON.stringify(scDSA[idx])));
				}
			}
		}
		for (let s = 0; s < localForecastAlignment.length; s++) {
			if (localForecastAlignment[s].type === "P") {
				let spidx = preparedScDSA.findIndex(x => x.skuid === localForecastAlignment[s].id && x.dataSourceID === localForecastAlignment[s].datasourceid);
				if (spidx > -1) {
					preparedScDSA[spidx].isVisible = false;
				}
			}
			else {
				let spidx = preparedScDSA.findIndex(x => x.productGroupID === localForecastAlignment[s].id && x.dataSourceID === localForecastAlignment[s].datasourceid);
				if (spidx > -1) {
					preparedScDSA[spidx].isVisible = false;
				}
			}
		}

		dispatch(setState("scDSA", preparedScDSA));
		if (ischanges) {
			dispatch(setState("scDSACopy", preparedScDSA));
		}
	};
	const getArrayFromPipeSeparatedStr = (str) => {
		return str.split("|");
	}

	const prepareAttributeList = (attributeList) => {
		let newAttrList = [];
		for (let attrInd = 0; attrInd < attributeList.length; ++attrInd) {
			const attrObj = attributeList[attrInd];
			let attributeName = attrObj.attributeName;

			const attributeObj = {
				attributeName,
			};
			attributeObj["attributeValues"] = attrObj.attributeValues;
			attributeObj["selectedAttributeValues"] = [];
			newAttrList.push(attributeObj);
		}
		return newAttrList;
	};

	const prepareMeasureList = (measureList) => {
		let newMeasureList = [];
		for (let mInd = 0; mInd < measureList.length; ++mInd) {
			const mObj = measureList[mInd];
			let measureName = mObj.measureName;
			let measureValue = mObj.measureValue;

			const msrObj = {
				measureName,
				measureValue,
			};
			newMeasureList.push(msrObj);
		}
		return newMeasureList;
	};

	const getUniqueIDs = (sku_pg) => {
		let skuid = null;
		let productGroupID = null;
		if (sku_pg.type === "PG") {
			productGroupID = sku_pg.id;
		} else if (sku_pg.type === "P") {
			skuid = sku_pg.id;
		} else if (sku_pg.hasOwnProperty("productGroupID")) {
			productGroupID = sku_pg.productGroupID;

		} else if (sku_pg.hasOwnProperty("productID")) {
			skuid = sku_pg.productID;
		}
		return {
			skuid,
			productGroupID,
		};
	};

	// const handle_AlignmentChange = (event) => {
	// 	console.log(scDSA);
	// 	let country = "";
	// 	let product = "";
	// 	let strength = "";
	// 	let panel = "";
	// 	if (scDSA.length > 0) {
	// 		let scDSAData = scDSA.find(x => x.dataSourceID === 5 && (x.skuid === selectedPG_SKU_ADSsID || x.productGroupID === selectedPG_SKU_ADSsID));
	// 		if (scDSAData !== undefined && scDSAData !== null) {
	// 			for (let i = 0; i < scDSAData.attributes.length; i++) {
	// 				if (scDSAData.attributes[i].attributeName === "Country") {
	// 					country = scDSAData.attributes[i].selectedAttributeValues.join('|');
	// 				}
	// 				if (scDSAData.attributes[i].attributeName === "Product") {
	// 					product = scDSAData.attributes[i].selectedAttributeValues.join('|');
	// 				}
	// 				if (scDSAData.attributes[i].attributeName === "Strength") {
	// 					strength = scDSAData.attributes[i].selectedAttributeValues.join('|');
	// 				}
	// 				if (scDSAData.attributes[i].attributeName === "Panel") {
	// 					panel = scDSAData.attributes[i].selectedAttributeValues.join('|');
	// 				}
	// 			}
	// 			let filter = {
	// 				countryid: countryID,
	// 				id: selectedPG_SKU_ADSsID,
	// 				country: country,
	// 				product: product,
	// 				strength: strength,
	// 				panel: panel
	// 			}
	// 			if (midasFilterParameters.id === filter.id) {
	// 				if (midasFilterParameters.country !== filter.country || midasFilterParameters.product !== filter.product || midasFilterParameters.strength !== filter.strength || midasFilterParameters.panel !== filter.panel) {
	// 					dispatch(MidasAlignmentFilter(filter));
	// 				}
	// 			}
	// 			else {
	// 				dispatch(MidasAlignmentFilter(filter));
	// 			}
	// 			dispatch(setState("midasFilterParameters", filter));
	// 		}

	// 	}
	// }
	useEffect(() => {
		if(premdrFilterParameters.countryid !== mdrFilterParameters.countryid || premdrFilterParameters.id !== mdrFilterParameters.id || premdrFilterParameters.product !== mdrFilterParameters.product || premdrFilterParameters.strength !== mdrFilterParameters.strength || premdrFilterParameters.channel !== mdrFilterParameters.channel){
			if(mdrFilterParameters !== null && mdrFilterParameters !== undefined && mdrFilterParameters !== [] && mdrFilterParameters.length !== 0){
				dispatch(MDRAlignmentFilter(mdrFilterParameters));
			}
			dispatch(setState("premdrFilterParameters", mdrFilterParameters));
		}
	},[mdrFilterParameters]);

	useEffect(() => {
		debugger
		if(prelocalFilterParameters.countryid !== localFilterParameters.countryid || 
			prelocalFilterParameters.id !== localFilterParameters.id || 
			prelocalFilterParameters.datasourceid !== localFilterParameters.datasourceid ||
			prelocalFilterParameters.customerName !== localFilterParameters.customerName || 
			prelocalFilterParameters.customerNumber !== localFilterParameters.customerNumber || 
			prelocalFilterParameters.company !== localFilterParameters.company || 
			prelocalFilterParameters.product !== localFilterParameters.product || 
			prelocalFilterParameters.pack !== localFilterParameters.pack || 
			prelocalFilterParameters.skuNumber !== localFilterParameters.skuNumber || 
			prelocalFilterParameters.skuName !== localFilterParameters.skuName){
			if(localFilterParameters !== null && localFilterParameters !== undefined && localFilterParameters !== [] && localFilterParameters.length !== 0){
				dispatch(LocalAlignmentFilter(localFilterParameters));
			}
			dispatch(setState("prelocalFilterParameters", localFilterParameters));
		}
	},[localFilterParameters]);


	useEffect(()=>{
		dispatch(setState("isLoadingAlignmentperSKU", true));
		const Timer = setTimeout(() => {
			let alignmentForSKU = JSON.parse(JSON.stringify(scDSA));
			let scDataSKU = alignmentForSKU.filter(x => (x.skuid === selectedPG_SKU_ADSsID || x.productGroupID === selectedPG_SKU_ADSsID));
			if(scDataSKU !== undefined && scDataSKU !== null){
				for(let i = 0 ; i < scDataSKU.length ; i ++){
					if(scDataSKU[i].dataSourceID === 2){
						if(premdrFilterParameters.id !== selectedPG_SKU_ADSsID){
							let scDSAData = alignmentForSKU.find(x => x.dataSourceID === 2 && (x.skuid === selectedPG_SKU_ADSsID || x.productGroupID === selectedPG_SKU_ADSsID));
							let channel = "";
							let product = "";
							let strength = "";
							let skuName = "";
							if (scDSAData !== undefined && scDSAData !== null) {
								dispatch(setState("isLoadingAlignment", true));
								const timer = setTimeout(() => {
								for (let i = 0; i < scDSAData.attributes.length; i++) {
									if (scDSAData.attributes[i].attributeName === "Channel") {
										channel = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "Product") {
										product = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "Strength") {
										strength = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "Sku Name") {
										skuName = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
								}
								let filter = {
									countryid: countryID,
									id: selectedPG_SKU_ADSsID,
									skuName: skuName,
									product: product,
									strength: strength,
									channel: channel
								}
								if (mdrFilterParameters.id === filter.id) {
									if (mdrFilterParameters.countryid !== filter.countryid || mdrFilterParameters.product !== filter.product || mdrFilterParameters.strength !== filter.strength || mdrFilterParameters.channel !== filter.channel || mdrFilterParameters.skuName !== filter.skuName) {
										dispatch(setState("mdrFilterParameters", filter));
									}else{
										dispatch(setState("isLoadingAlignment", false));
									}
								}else{
									dispatch(setState("mdrFilterParameters", filter));
								}
								},1);
							}
						}
					}
					else if (scDataSKU[i].dataSourceID > 5){
						if(premdrFilterParameters.id !== selectedPG_SKU_ADSsID){
							let scDSAData = alignmentForSKU.find(x => x.dataSourceID === scDataSKU[i].dataSourceID && (x.skuid === selectedPG_SKU_ADSsID || x.productGroupID === selectedPG_SKU_ADSsID));
							let customerName = "";
							let customerNumber = "";
							let company = "";
							let product = "";
							let pack = "";
							let skuNumber = "";
							let skuName = "";
							if (scDSAData !== undefined && scDSAData !== null) {
								dispatch(setState("isLoadingAlignment", true));
								const timer = setTimeout(() => {
								for (let i = 0; i < scDSAData.attributes.length; i++) {
									if (scDSAData.attributes[i].attributeName === "Customer Name") {
										customerName = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "Customer Number") {
										customerNumber = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "Company") {
										company = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "Product name") {
										product = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "Pack Name") {
										pack = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "SKU#") {
										skuNumber = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
									if (scDSAData.attributes[i].attributeName === "SKU Name") {
										skuName = scDSAData.attributes[i].selectedAttributeValues.join('|');
									}
								}
								let filter = {
									countryid: countryID,
									datasourceid : scDataSKU[i].dataSourceID,
									id: selectedPG_SKU_ADSsID,
									skuName: skuName,
									product: product,
									skuNumber: skuNumber,
									pack: pack,
									company: company,
									customerNumber: customerNumber,
									customerName: customerName
								}
								if (localFilterParameters.id === filter.id) {
									if (localFilterParameters.countryid !== filter.countryid || 
										localFilterParameters.datasourceid !== filter.datasourceid || 
										localFilterParameters.skuName !== filter.skuName || 
										localFilterParameters.product !== filter.product || 
										localFilterParameters.skuNumber !== filter.skuNumber|| 
										localFilterParameters.pack !== filter.pack || 
										localFilterParameters.company !== filter.company || 
										localFilterParameters.customerNumber !== filter.customerNumber|| 
										localFilterParameters.customerName !== filter.customerName) {
										dispatch(setState("localFilterParameters", filter));
									}else{
										dispatch(setState("isLoadingAlignment", false));
									}
								}else{
									dispatch(setState("localFilterParameters", filter));
								}
								},5);
							}
						}
					}

				}
			}
			dispatch(setState("isLoadingAlignmentperSKU", false));
		},1);
	}, [scDSA, selectedPG_SKU_ADSsID]);

	return (
		<Box>
			{scDSA?.map((data, scDSAInd) => {
				if (data.dataSourceName !== "Ex-Factory") {
					if (
						(data.skuid === selectedPG_SKU_ADSsID ||
							data.productGroupID === selectedPG_SKU_ADSsID) && data.isVisible === true
					) {
						return (
							<Accordion key={scDSAInd}>
								<AccordionSummary sx={{backgroundColor: "#f0f7fe", minHeight: "30px !important",}}
									expandIcon={<ExpandMoreIcon />}
									aria-controls="panel1a-content"
									id="panel1a-header"
								>
									<Typography sx={{fontWeight: 600,}}>{data.dataSourceName}</Typography>
								</AccordionSummary>
								<AccordionDetails>
									{data.attributes.map((attrObj, attrInd) => {
										const leftList = attrObj.attributeValues;
										const rightList = attrObj.selectedAttributeValues;

										if (attrObj.attributeName !== "hide") {
											if (attrObj.attributeName != 'Channel' && attrObj.attributeName != 'Panel' && attrObj.attributeName != 'Product' &&
												attrObj.attributeName != 'Sku Name' && attrObj.attributeName != 'Strength' && attrObj.attributeName != 'Product name' && attrObj.attributeName != 'Pack Name'
												&& attrObj.attributeName != 'SKU#' && attrObj.attributeName != 'SKU Name') {
												return (
													<>
														<Typography sx={{fontSize: 14, mb: 1, mt: 1}} variant="subtitle2">
															{attrObj.attributeName}
														</Typography>
														<TransferListDSA
															leftList={leftList}
															rightList={rightList}
															scDSAInd={scDSAInd}
															attrIndex={attrInd}
															selectedPG_SKU_ADSs={
																selectedPG_SKU_ADSs
															}
															selectedPG_SKU_ADSsID={
																selectedPG_SKU_ADSsID
															}
															datasourceid={data.dataSourceID}
															attributeName={attrObj.attributeName}

														/>
													</>
												);
											}
										}
									})}
									{data.measure.length > 0 ? (
										<>
											<Typography variant="subtitle2" sx={{fontSize: 14, mt: 4,mb: 2,}}>
												Measure
											</Typography>
											<TransferListDSAMeasure
												leftList={data.measure}
												rightList={data.selectedMeasure}
												scDSAInd={scDSAInd}
											/>
										</>
									) : (
										""
									)}
									<div style={{ borderBottom: "dashed 2px", padding: "20px" }}></div>
									{data.attributes.map((attrObj, attrInd) => {
										const leftList = attrObj.attributeValues;
										const rightList = attrObj.selectedAttributeValues;

										if (attrObj.attributeName !== "hide") {
											if (attrObj.attributeName == 'Channel') {
												return (
													<>
														<Typography variant="subtitle2" sx={{fontSize: 14, mt: 4,mb: 2,}}>
															{attrObj.attributeName}
														</Typography>
														<TransferListDSA
															leftList={leftList}
															rightList={rightList}
															scDSAInd={scDSAInd}
															attrIndex={attrInd}
															selectedPG_SKU_ADSs={
																selectedPG_SKU_ADSs
															}
															selectedPG_SKU_ADSsID={
																selectedPG_SKU_ADSsID
															}
															datasourceid={data.dataSourceID}
															attributeName={attrObj.attributeName}

														/>
													</>
												);
											}
										}
									})}
									{data.attributes.map((attrObj, attrInd) => {
										const leftList = attrObj.attributeValues;
										const rightList = attrObj.selectedAttributeValues;

										if (attrObj.attributeName !== "hide") {
											if ( attrObj.attributeName == 'Panel' || attrObj.attributeName == 'Product' ||
												attrObj.attributeName == 'Sku Name' || attrObj.attributeName == 'Strength' || attrObj.attributeName == 'Product name' || attrObj.attributeName == 'Pack Name'
												|| attrObj.attributeName == 'SKU#' || attrObj.attributeName == 'SKU Name') {
												return (
													<>
														<Typography variant="subtitle2" sx={{fontSize: 14, mt: 4,mb: 2,}}>
															{attrObj.attributeName}
														</Typography>
														<TransferListDSA
															leftList={leftList}
															rightList={rightList}
															scDSAInd={scDSAInd}
															attrIndex={attrInd}
															selectedPG_SKU_ADSs={
																selectedPG_SKU_ADSs
															}
															selectedPG_SKU_ADSsID={
																selectedPG_SKU_ADSsID
															}
															datasourceid={data.dataSourceID}
															attributeName={attrObj.attributeName}

														/>
													</>
												);
											}
										}
									})}
								</AccordionDetails>
							</Accordion>
						);
					}
				}
				return null;
			})}
		</Box>
	);
}
